import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Slider from "react-slick";

const MainSlider = ({ banners }) => {
  const settings = {
    dots: true,
    fade: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div>
      <Slider {...settings}>
        {banners &&
          banners.length &&
          banners.map((b, index) => {
            return (
              <div className="position-relative" key={index}>
                <div className="content d-none">
                  <div className="container">
                    <div className="row">
                      <div className="col-8">
                        {(b?.ctabtns.length &&
                          b?.ctabtns.map((c, i) => {
                            return (
                              <Button
                                variant="primary"
                                className="button-primary"
                                onClick={() => {
                                  window.location.href = c.actionLink;
                                }}
                              >
                                {c.label}
                              </Button>
                            );
                          })) ||
                          null}
                      </div>
                    </div>
                  </div>
                </div>
                <img src={b.link} alt="First Slide" />
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default MainSlider;
